// extracted by mini-css-extract-plugin
export default {"row":"job-selected-filter_row__tqfdu","badge":"job-selected-filter_badge__VC7-7"};